import React from 'react';

const IconImage = ({ src, alt, width, height, className, style }) => {
  if (!width) {
    width = 16;
  }
  if (!height) {
    height = 16;
  }
  return (
    <img
      src={require(`../dataSource/img/${src}`)}
      width={width}
      height={height}
      className={`${className ? 'no-wh ' + className : 'no-wh'}`}
      alt={alt}
      style={style}
    />
  );
};

export default IconImage;
